export default {
  SHOW_OVERLAY: 'showoverlay',
  SHOW_BANNER: 'showbanner'
};
